import { useState } from "react";
import { Box, Typography } from "@mui/material";
import HumbeeGlassDialog from "../../../v2/MUI_custom_component/Modal/HumbeeGlassDialog";
import { CustomButton } from "../../../v2/MUI_custom_component";
import digilockerImg from "../../../assets/digilocker-app-screenshot.png";
import aadhaarImg from "../../../assets/aadhaar-logo.png";

const METHODS = [
  { key: "DIGILOCKER", label: "Digilocker (recommended)", img: digilockerImg },
  { key: "AADHAAR", label: "Aadhaar", img: aadhaarImg },
];

export const DigiLockerKycModal = ({
  open,
  onClose,
  mobileNumber,
  onContinue,
  loading = false,
}) => {
  const [method, setMethod] = useState("DIGILOCKER");

  const handleContinue = () => {
    onContinue?.(method);
  };

  return (
    <HumbeeGlassDialog open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="h3">
              {`Is your mobile number ${mobileNumber} linked with your Aadhaar?`}
            </Typography>
            <Typography variant="p3" sx={{ color: "#333" }}>
              Please select to continue.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2 }}>
            {METHODS.map((opt) => {
              const selected = method === opt.key;
              return (
                <Box
                  key={opt.key}
                  onClick={() => setMethod(opt.key)}
                  sx={{
                    width: 149,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 0.5,
                    cursor: "pointer",
                  }}>
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      borderRadius: "16px",
                      border: selected ? "2px solid" : "1px solid",
                      borderColor: selected ? "primary.main" : "#8C8C8C",
                    }}>
                    <Box
                      component="img"
                      src={opt.img}
                      alt={opt.label}
                      sx={{
                        width: 100,
                        height: 112,
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="p3"
                    sx={{
                      textAlign: "center",
                      color: selected ? "#333" : "#666",
                    }}>
                    {opt.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        <CustomButton
          label="Continue"
          onClick={handleContinue}
          loading={loading}
          disabled={loading}
          sx={{ width: 320, maxWidth: "100%" }}
        />
      </Box>
    </HumbeeGlassDialog>
  );
};

export default DigiLockerKycModal;
